"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
require("rxjs/add/observable/from");
require("rxjs/add/operator/toPromise");
var current_language_manager_1 = require("./current-language.manager");
var SessionDataProviderImpl = /** @class */ (function () {
    function SessionDataProviderImpl(languageService, authenticationService, currentLanguageManager) {
        this.authenticationService = authenticationService;
        this._openSubscriptions = [];
        this._languageService = languageService;
        this._currentLanguageManager = currentLanguageManager;
        this._currentLanguage = new ReplaySubject_1.ReplaySubject(1);
        this.initCurrentLanguage();
    }
    SessionDataProviderImpl.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    SessionDataProviderImpl.prototype.getCurrentUserData = function () {
        return this.authenticationService.getUserData();
    };
    // Override
    SessionDataProviderImpl.prototype.getCurrentLanguage = function () {
        return this._currentLanguage;
    };
    SessionDataProviderImpl.prototype.setCurrentLanguageId = function (languageId) {
        var _this = this;
        this._openSubscriptions.push(this._languageService.getLanguage(languageId).subscribe(function (language) {
            _this._currentLanguageManager.setLanguageId(languageId);
            _this._currentLanguage.next(language);
        }));
    };
    SessionDataProviderImpl.prototype.isLoggedOn = function () {
        return this.authenticationService.isLoggedOn();
    };
    SessionDataProviderImpl.prototype.logout = function () {
        this.authenticationService.logout();
    };
    /**
     * Initializes current language subject with current language which could be provided by current language manager, otherwise it is the default
     * language. In both cases the language with which current language subject is initialized is retrieved by subscribing to observables by
     * before-mentioned conditions, because languages are loaded asynchronously, so they may be not loaded yet
     * @private
     */
    SessionDataProviderImpl.prototype.initCurrentLanguage = function () {
        var _this = this;
        var languageId = this._currentLanguageManager.getLanguageId();
        if (languageId && languageId !== -1) {
            this._openSubscriptions.push(this._languageService
                .getAvailableLanguages()
                .flatMap(function (langs) { return Observable_1.Observable.from(langs); })
                .filter(function (language) { return language.getId() === languageId; })
                .subscribe(function (language) {
                _this._currentLanguage.next(language);
            }));
        }
        else {
            this._openSubscriptions.push(this._languageService.getDefaultLanguage().subscribe(function (language) {
                _this._currentLanguage.next(language);
            }));
        }
    };
    SessionDataProviderImpl = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            idm_authentication_client_js_1.AuthenticationService,
            current_language_manager_1.CurrentLanguageManager])
    ], SessionDataProviderImpl);
    return SessionDataProviderImpl;
}());
exports.SessionDataProviderImpl = SessionDataProviderImpl;
//# sourceMappingURL=session-data.provider.impl.js.map